import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { colours } from '@qflow/theme'

import { icons, ColourButton, Spacer, Label } from 'portal/lib/primitives'

export function EditButton({
  children = 'Edit',
  iconOnly = false,
  disabled = false,
  ...props
}) {
  if (iconOnly) {
    return (
      <Tooltip title={children}>
        <ColourButton.BasicBorderless
          id="EditButton"
          style={{ padding: '4px 7px', borderRadius: '50%' }}
          disabled={disabled}
          {...props}
        >
          <icons.EditPencil
            colour={disabled ? colours.BORDER_GREY : colours.CORE_NAVY}
          />
        </ColourButton.BasicBorderless>
      </Tooltip>
    )
  }

  return (
    <ColourButton.Action id="EditButton" {...props}>
      <icons.EditPencil colour="currentColor" />
      <Spacer.Fine />
      <Label isChild colour="inherit">
        {children}
      </Label>
    </ColourButton.Action>
  )
}

EditButton.propTypes = {
  ...ColourButton.Action.propTypes,
  children: PropTypes.string
}
